import { createSelectDispatchers } from '../createSelectDispatcher';


export const createScopedDispatchers = (actionMap, payloadKey) => {
  const dispatchers = createSelectDispatchers(payloadKey);

  return {
    selectAllDispatch: (dispatch, name, locationList, specificLocationList, machineList, status) =>
      dispatchers.selectAll(dispatch, actionMap, name, locationList, specificLocationList, machineList, status),

    selectLocationDispatch: (dispatch, name, locationList, specificLocationList, machineList, newSelectedLocations, newSpecificLocations, newMachines) =>
      dispatchers.selectLocation(dispatch, actionMap, name, locationList, specificLocationList, machineList, newSelectedLocations, newSpecificLocations, newMachines),

    selectSpecificLocationDispatch: (dispatch, name, specificLocationList, machineList, newSpecificLocations, newMachines) =>
      dispatchers.selectSpecificLocation(dispatch, actionMap, name, specificLocationList, machineList, newSpecificLocations, newMachines),

    selectMachineDispatch: (dispatch, name, extraOption, locationIdx, specLocationIdx, machineIdx, newSelectedMachine, status) =>
      dispatchers.selectMachine(dispatch, actionMap, name, extraOption, locationIdx, specLocationIdx, machineIdx, newSelectedMachine, status),
  };
};
